export default __webpack_public_path__ + "static/media/settings.d3ac44b9.svg";